export default "__VITE_ASSET__770c3e92__"